var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('partner-dept-moves',{attrs:{"partner-id":_vm.branchDetails.Partner_ID,"partner-name":_vm.branchDetails.PartnerBrandName}})}
var staticRenderFns = []

export { render, staticRenderFns }